export default "__VITE_ASSET__C9$JBq7q__"